import "../css/myprofilecontainer.css";
//

const MyProfileContainer = ({
  title,
  onEdit,
  children,
  className,
  cv,
  pic,
  isKyc,
}) => {
  return (
    <div className={`card-container ${className}`}>
      <div className="card-header">
        {title && <div className="card-title">{title}</div>}
        {pic && children}
        {!isKyc && (
          <svg
            width="74"
            height="31"
            viewBox="0 0 74 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="73"
              height="30"
              rx="4.5"
              fill="white"
              stroke="#1550A1"
            />
            <path
              d="M40.5264 18.6396V20H35.2422V18.6396H40.5264ZM35.7275 10.0469V20H34.0117V10.0469H35.7275ZM39.8359 14.2031V15.543H35.2422V14.2031H39.8359ZM40.4922 10.0469V11.4141H35.2422V10.0469H40.4922ZM46.1387 18.4688V9.5H47.793V20H46.2959L46.1387 18.4688ZM41.3262 16.3838V16.2402C41.3262 15.6797 41.3923 15.1693 41.5244 14.709C41.6566 14.2441 41.848 13.8454 42.0986 13.5127C42.3493 13.1755 42.6546 12.918 43.0146 12.7402C43.3747 12.5579 43.7803 12.4668 44.2314 12.4668C44.6781 12.4668 45.07 12.5534 45.4072 12.7266C45.7445 12.8997 46.0316 13.1481 46.2686 13.4717C46.5055 13.7907 46.6947 14.1735 46.8359 14.6201C46.9772 15.0622 47.0775 15.5544 47.1367 16.0967V16.5547C47.0775 17.0833 46.9772 17.5664 46.8359 18.0039C46.6947 18.4414 46.5055 18.8197 46.2686 19.1387C46.0316 19.4577 45.7422 19.7038 45.4004 19.877C45.0632 20.0501 44.6689 20.1367 44.2178 20.1367C43.7712 20.1367 43.3678 20.0433 43.0078 19.8564C42.6523 19.6696 42.3493 19.4076 42.0986 19.0703C41.848 18.7331 41.6566 18.3366 41.5244 17.8809C41.3923 17.4206 41.3262 16.9215 41.3262 16.3838ZM42.9736 16.2402V16.3838C42.9736 16.721 43.0033 17.0355 43.0625 17.3271C43.1263 17.6188 43.2243 17.8763 43.3564 18.0996C43.4886 18.3184 43.6595 18.4915 43.8691 18.6191C44.0833 18.7422 44.3385 18.8037 44.6348 18.8037C45.0085 18.8037 45.3161 18.7217 45.5576 18.5576C45.7992 18.3936 45.9883 18.1725 46.125 17.8945C46.2663 17.612 46.362 17.2975 46.4121 16.9512V15.7139C46.3848 15.445 46.3278 15.1943 46.2412 14.9619C46.1592 14.7295 46.0475 14.5267 45.9062 14.3535C45.765 14.1758 45.5895 14.0391 45.3799 13.9434C45.1748 13.8431 44.931 13.793 44.6484 13.793C44.3477 13.793 44.0924 13.8568 43.8828 13.9844C43.6732 14.112 43.5 14.2874 43.3633 14.5107C43.2311 14.734 43.1331 14.9938 43.0693 15.29C43.0055 15.5863 42.9736 15.903 42.9736 16.2402ZM51.2793 12.6035V20H49.625V12.6035H51.2793ZM49.5156 10.6621C49.5156 10.4115 49.5977 10.2041 49.7617 10.04C49.9303 9.87142 50.1628 9.78711 50.459 9.78711C50.7507 9.78711 50.9808 9.87142 51.1494 10.04C51.318 10.2041 51.4023 10.4115 51.4023 10.6621C51.4023 10.9082 51.318 11.1133 51.1494 11.2773C50.9808 11.4414 50.7507 11.5234 50.459 11.5234C50.1628 11.5234 49.9303 11.4414 49.7617 11.2773C49.5977 11.1133 49.5156 10.9082 49.5156 10.6621ZM56.4746 12.6035V13.8066H52.3047V12.6035H56.4746ZM53.5078 10.792H55.1553V17.9561C55.1553 18.1839 55.1872 18.3594 55.251 18.4824C55.3193 18.6009 55.4128 18.6807 55.5312 18.7217C55.6497 18.7627 55.7887 18.7832 55.9482 18.7832C56.0622 18.7832 56.1715 18.7764 56.2764 18.7627C56.3812 18.749 56.4655 18.7354 56.5293 18.7217L56.5361 19.9795C56.3994 20.0205 56.2399 20.057 56.0576 20.0889C55.8799 20.1208 55.6748 20.1367 55.4424 20.1367C55.0641 20.1367 54.7292 20.0706 54.4375 19.9385C54.1458 19.8018 53.918 19.5807 53.7539 19.2754C53.5898 18.9701 53.5078 18.5645 53.5078 18.0586V10.792Z"
              fill="#1550A1"
            />
            <g clip-path="url(#clip0_197_745)">
              <path
                d="M12.875 22.125H15.2188L22.1312 15.2125L19.7875 12.8688L12.875 19.7813V22.125ZM14.125 20.3L19.7875 14.6375L20.3625 15.2125L14.7 20.875H14.125V20.3Z"
                fill="#1550A1"
              />
              <path
                d="M22.4811 11.0563C22.2373 10.8125 21.8436 10.8125 21.5998 11.0563L20.4561 12.2L22.7998 14.5438L23.9436 13.4C24.1873 13.1563 24.1873 12.7625 23.9436 12.5188L22.4811 11.0563Z"
                fill="#1550A1"
              />
            </g>
            <defs>
              <clipPath id="clip0_197_745">
                <rect
                  width="15"
                  height="15"
                  fill="white"
                  transform="translate(11 9)"
                />
              </clipPath>
            </defs>
          </svg>
        )}
      </div>
      <div className="card-header">{cv && children}</div>
    </div>
  );
};
export default MyProfileContainer;
